<template>

  <div class="pages-download">
    <!-- <div class="the-banner"></div> -->
    <div class="bgbox-white" >
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-conts" >
          <div class="module-title">
            <span class="title-cn">神行者加速器下载</span>
            <span class="title-en">SMART ACCEL DOWNLOAD</span>
            <span class="title-info">- 加速器的安装包及安装、更新说明 -</span>
          </div>
          <!-- <div class="module-view">
            <div class="view-title">
              <span class="title-cn">Windows版游戏加速器下载</span>
               <span class="title-en">windows</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>网吧版本：</span>AIRAPIDLINK-r1[2024-07-03]</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-windows">
                    <a href="http://iso.stacksnet.com/update/Rapidlink.exe">
                      <span>本地下载</span>
                    </a>
                  </div>
                 
                </div>
              </el-col>
            </div>
          </div> -->
<!-- 
          <div class="module-view">
   
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>绿色版本：</span>AIRAPIDLINK-l1[2024-07-03]</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-windows">
                    <a href="http://iso.stacksnet.com/update/Rapidlink.tar.gz">
                      <span>本地下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-wywp">
                    <a href="http://down.netsxz.com:8089/game/update/Rapidlink.tar.gz" target="_blank" rel="noopener noreferrer">
                      <span>备用下载线路</span>
                    </a>                    
                  </div>
      
                </div>
              </el-col>
            </div>
          </div> -->
          
          <div class="module-view">
            <!-- <div class="view-title">
              <span class="title-cn">路由安装ISO[不支持D525]</span>
              <span class="title-en">ROUTING INSTALLATION ISO[NOT SUPPORT D525]</span>
            </div> -->
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>神行者加速器：</span>AIRAPIDLINK-r1[2025-01-17] </li>
                    <li><span>加速器只支持WindowsPC端使用</span></li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-windows">
                    <a href="http://down.netsxz.com:8089/game/update/SxzSetup1.0.7.23.exe">
                      <span>本地下载</span>
                    </a>
                  </div>
                 
                </div>
              </el-col>
            </div>
          </div>


          <!-- <div class="module-view">
            <div class="view-title">
              <span class="title-cn">Android版本游戏加速器下载</span>
              <span class="title-en">android</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>1.0.16</li>
                    <li><span>MD5：53857614b27da9c49423212ac2e2cc82</span></li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-andorid">
                    <a href="https://down.netsxz.com:8443/Client/sdwan.apk" target="_blank" rel="noopener noreferrer">
                      <span>Android下载</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div> -->
<!--           
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">IOS版游戏加速器下载</span>
              <span class="title-en">ios</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>1.0.12</li>
                    
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-ios">
                    <a href="https://apps.apple.com/cn/app/xwanclient/id1546185886" target="_blank"
                       rel="noopener noreferrer">
                      <span>IOS下载</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div> -->
<!-- 
                    <div class="module-view">
            <div class="view-title">
              <span class="title-cn">MAC版游戏加速器下载</span>
              <span class="title-en">mac</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>1.0.12</li>
                   
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdxz">
                    <a href="https://apps.apple.com/cn/app/xwanclient/id1546185886" target="_blank"
                       rel="noopener noreferrer">
                      <span>MAC下载</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div> -->
          <!-- </div> -->

        </div>




      </el-col>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
<style>
.el-collapse-item__header{
  font-size: 20px;
  color: #06c;
}
#app{
  overflow: auto !important;
}

</style>
<style lang="scss" scoped>
.the-banner {
  height: 400px;
  background-image: url("../../assets/images/accel11.png");
  background-repeat: no-repeat;
  background-position: center;
}
.downconts-box {
  overflow: hidden;

  .list-box {
    ul {
      padding: 10px 0;
      margin: 0;

      li {
        list-style: none;
        font-size: 16px;
        color: #1f1f1f;
        padding: 10px 0;
        border-bottom: 1px solid #e3e6e7;

        span {
          color: #757575;
        }

        pre {
          margin: 0;
          background: #333;
          color: #fff;
          padding: 6px;
          box-sizing: border-box;
        }
      }
    }
  }

  .downbtn-box {
    float: right;
    text-align: right;

    .downbtn {
      width: 100px;
      height: 100px;
      background: #0066cc;
      display: inline-block;
      vertical-align: top;
      margin-right: 20px;
      background-size: 60px !important;
      background-position: center 10px !important;
      cursor: pointer;
      position: relative;

      &:last-child {
        margin: 0;
      }

      &.downbtn-bdxz {
        background: url("../../assets/images/download-icon1.png") #0066cc no-repeat;
      }

      &.downbtn-wywp {
        background: url("../../assets/images/download-icon2.png") #0066cc no-repeat;
      }

      &.downbtn-bdwp {
        background: url("../../assets/images/download-icon3.png") #0066cc no-repeat;
      }

      &.downbtn-andorid {
        background: url("../../assets/images/android.png") #0066cc no-repeat;
      }

      &.downbtn-ios {
        background: url("../../assets/images/ios.png") #0066cc no-repeat;
      }
      &.downbtn-windows {
        background: url("../../assets/images/Windows.png") #0066cc no-repeat;
      }

      a {
        display: block;
        width: 100%;
        height: 100%;
      }

      span {
        display: block;
        width: 100%;
        font-size: 14px;
        color: #fff;
        text-align: center;
        position: absolute;
        bottom: 10px;
        line-height: 1;
      }
    }
  }
}
.bgbox-white{
  padding: 15px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}
.module-title{
  text-align: center;
  padding-bottom: 40px;
  .title-cn{
    display: block;
    font-size: 30px;
    font-weight: bold;
    color: #1f1f1f;
  }
  .title-en{
    display: block;
    font-size: 12px;
    font-weight: 400;
    color: #757575;
    line-height: 20px;
  }
  .title-info{
    display: block;
    font-size: 14px;
    color: #999999;
  }
}
.view-title{
  .title-cn{
    display: block;
    font-size: 20px;
    color: #1f1f1f;
    font-family: "PingFang SC";
  }
  .title-en{
    display: block;
    font-size: 12px;
    color: #757575;
    line-height: 20px;
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;
    &::before{
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #3067ba;
      position: absolute;
      left: 0;
      top: 6px;
    }
  }
}

// 下载内容共用部分
.module-conts{
  padding-bottom: 80px;
}
.module-view{
  padding-bottom: 40px;
}
.downconts-box{
  overflow: hidden;
  .list-box{
    ul{
      padding: 10px 0;
      margin: 0;
      li{
        list-style: none;
        font-size: 16px;
        color: #1f1f1f;
        padding: 10px 0;
        border-bottom: 1px solid #e3e6e7;
        span{
          color: #757575;
        }
        pre{
          margin: 0;
          background: #333;
          color: #fff;
          padding: 6px;
          box-sizing: border-box;
        }
      }
    }
  }
  .downbtn-box{
    float: right;
    text-align: right;
    .downbtn{
      width: 100px;
      height: 100px;
      background: #0066cc;
      display: inline-block;
      vertical-align: top;
      margin-right: 20px;
      background-size: 60px !important;
      background-position: center 10px !important;
      cursor: pointer;
      position: relative;
      &:last-child{
        margin: 0;
      }
      &.downbtn-bdxz{
        background: url("../../assets/images/download-icon1.png") #0066cc no-repeat;
      }
      &.downbtn-wywp{
        background: url("../../assets/images/download-icon2.png") #0066cc no-repeat;
      }
      &.downbtn-bdwp{
        background: url("../../assets/images/download-icon3.png") #0066cc no-repeat;
      }
      a{
        display: block;
        width: 100%;
        height: 100%;
      }
      span{
        display: block;
        width: 100%;
        font-size: 14px;
        color: #fff;
        text-align: center;
        position: absolute;
        bottom: 10px;
        line-height: 1;
      }
    }
  }
}
.module-tools{
  overflow: hidden;
  background: #f5f5f5;
  .tools-item{
    width: 120px;
    height: 150px;
    margin: 0 auto;
    padding: 10px;
    box-sizing: border-box;
    .item{
      width: 100%;
      height: 100%;
      cursor: pointer;
      background-size: 87px !important;
      background-position: center 10px !important;
      position: relative;
      transition: all 0.3s ease;
      &.item-gx{
        background: url("../../assets/images/download-icon4.png") no-repeat;
      }
      &.item-az{
        background: url("../../assets/images/download-icon5.png") no-repeat;
      }
      &.item-js{
        background: url("../../assets/images/download-icon6.png") no-repeat;
      }
      &.item-sy{
        background: url("../../assets/images/download-icon7.png") no-repeat;
      }
      a{
        display: block;
        width: 100%;
        height: 100%;
      }
      span{
        font-size: 18px;
        color: #1f1f1f;
        position: absolute;
        bottom: 6px;
        width: 100%;
        text-align: center;
      }
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }
}



// 中等屏幕
@media screen and (max-width: 991px) {
  .downconts-box{
    .downbtn-box{
      float: left;
      text-align: left;
      .downbtn{
        width: 80px;
        height: 80px;
        margin-right: 10px;
        background-size: 40px !important;
        span{
          font-size: 12px;
        }
      }
    }
  }
  
}

// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../assets/images/download-banner2.jpg");
  }
}
</style> 
